module.exports = __webpack_public_path__ + "img/sitelogo.80ab833b.png";